export default __webpack_public_path__ + "static/Схема_заполнения декларации в ЛК-2109583a9923be4ce0f93f94ce155f7a.pdf";